<div class="p-4 position-relative">
  <span class="close-icon" (click)="onCancel()">
    <mat-icon >close</mat-icon>
  </span>
  <h2 mat-dialog-title class="text-heading">Schedule Downtime</h2>
  <mat-dialog-content>
    <div>
      You can initiate maintenance immediately or schedule it for a later time.
    </div>
    <form #downtimeForm="ngForm" (ngSubmit)="onSubmit()" class="mt-3">
      <div class="d-flex align-items-center">
        <input
          type="radio"
          name="start-maintenance"
          id="start-maintenance"
          [(ngModel)]="startMaintenance"
          [value]="true"
          class="mr-2 select-btn"
          (ngModelChange)="validateEndDate(endDateRef)"
        />
        <label for="start-maintenance">Start maintenance now</label>
      </div>
      <div class="form-group mt-3">
        <div class="d-flex align-items-center">
          <input
            type="radio"
            name="schedule-maintenance"
            id="schedule-maintenance"
            [(ngModel)]="startMaintenance"
            [value]="false"
            class="mr-2 select-btn"
            #scheduleMaintenance="ngModel"
            (ngModelChange)="validateEndDate(endDateRef)"
          />
          <label for="schedule-maintenance">Schedule maintenance</label>
        </div>
        <div
          class="d-flex align-items-center mt-2 ml-4"
          [class.disabled-div]="startMaintenance"
        >
          <mat-form-field class="date-picker mr-3" floatLabel="always">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              required
              [min]="minDate"
              placeholder="MM/DD/YYYY"
              name="startDate"
              [(ngModel)]="startDate"
              #startDateRef="ngModel"
              (click)="startDatePicker.open()"
              (ngModelChange)="validateStartDate(startDateRef, endDateRef)"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="startDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="date-picker p-2" floatLabel="always">
            <mat-label>Start Time</mat-label>
            <input
              matInput
              class="mt-1"
              aria-label="24hr format"
              [ngxTimepicker]="startTimeClock"
              [format]="24"
              placeholder="HH:MM"
              required
              name="startTime"
              [(ngModel)]="startTime"
              #startTimeRef="ngModel"
              (ngModelChange)="validateStartDate(startDateRef, endDateRef)"
            />
            <button
              class="timer-btn mt-1"
              type="button"
              (click)="startTimeClock.open()"
            >
              <mat-icon>access_time</mat-icon>
            </button>
            <ngx-material-timepicker #startTimeClock></ngx-material-timepicker>
          </mat-form-field>
        </div>
        <div *ngIf="!startMaintenance && ((startDateRef.touched && !startDateRef.control.value) || (startTimeRef.touched && !startTimeRef.control.value) || (submitForm && (!startDateRef.control.value || !startTimeRef.control.value)))">
          <small class="text-danger">Both Start Date and Start Time are required</small>
        </div>
        <div *ngIf="!startMaintenance && startDateRef?.errors?.startDateTime">
          <small class="text-danger">{{ startDateRef?.errors?.startDateTime }}</small>
        </div>
      </div>
      <div class="mt-4">
        <div>
          <mat-slide-toggle
            [checked]="endMaintenance"
            (change)="endMaintenance=!endMaintenance"
            class="mr-1"
            #endMaintenanceRef
            id="start-maintenance"
          ></mat-slide-toggle>
          <label for="end-maintenance">Set maintenance end time</label>
        </div>
        <div class="d-flex align-items-center mt-2 ml-4" [class.disabled-div]="!endMaintenance">
          <mat-form-field class="date-picker mr-3" floatLabel="always">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              required
              [min]="minDate"
              placeholder="MM/DD/YYYY"
              [(ngModel)]="endDate"
              #endDateRef="ngModel"
              name="endDate"
              (click)="endDatePicker.open()"
              (ngModelChange)="validateEndDate(endDateRef)"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="endDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
          </mat-form-field>

          <mat-form-field class="date-picker p-2" floatLabel="always">
            <mat-label>End Time</mat-label>
            <input
              matInput
              class="mt-1"
              aria-label="24hr format"
              [ngxTimepicker]="endTimeClock"
              [format]="24"
              placeholder="HH:MM"
              required
              [(ngModel)]="endTime"
              #endTimeRef="ngModel"
              name="endTime"
              (ngModelChange)="validateEndDate(endDateRef)"
            />
            <button
              class="timer-btn mt-1"
              type="button"
              (click)="endTimeClock.open()"
            >
              <mat-icon>access_time</mat-icon>
            </button>
            <ngx-material-timepicker #endTimeClock></ngx-material-timepicker>
          </mat-form-field>
        </div>
        <div *ngIf="endMaintenance && ((endDateRef.touched && !endDateRef.control.value) || (endTimeRef.touched && !endTimeRef.control.value) || (submitForm && (!endDateRef.control.value || !endTimeRef.control.value)))">
          <small class="text-danger">Both End Date and End Time are required</small>
        </div>
        <div *ngIf="endMaintenance && endDateRef?.errors?.endBeforeStart">
          <small class="text-danger">{{ endDateRef?.errors?.endBeforeStart }}</small>
        </div>
      </div>
      <div class="d-flex align-items-center mt-4">
        <button type="submit" class="btn blue-btn mr-3" [class.disable]="(!startMaintenance && (startDateRef?.errors || startTimeRef?.errors))||(endMaintenance && (endDateRef?.errors || endTimeRef?.errors))">Submit</button>
        <button class="btn white-btn" (click)="onCancel()" type="button">Cancel</button>
      </div>
    </form>
  </mat-dialog-content>
</div>
